/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { AbstractResourceService } from '@irian-ro/abstract-resource';
import { UserPushNotificationTokenDTO } from './user-push-notification-token-dto.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserPushNotificationTokenResourceService extends AbstractResourceService<
  unknown,
  UserPushNotificationTokenDTO,
  unknown,
  null
> {
  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('userPushNotificationTokenUrl'),
      UserPushNotificationTokenDTO
    );
  }

  invalidate(userUuid: string, device: string): Observable<unknown> {
    return <Observable<unknown>> this.httpClient?.post(`${this.url}/invalidate/${userUuid}/${device}`, null);
  }
}
